import type { InvoicingRoute } from '../types/agreements.types';

export const canInvoice = (route: InvoicingRoute | string | undefined): boolean => route === 'open';
